<template>
    <div class="oilAnd-grease">
        <table>
            <thead>
                <tr>
                    <th>用途</th>
                    <th>油液/润滑剂型号</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>发动机机油</td>
                    <td>使用显示有dexos 认证标志且粘度等级正确的发动机机油。</td>
                </tr>
                <tr>
                    <td>挡风玻璃清洗剂</td>
                    <td>满足地区防冻要求的上汽通用汽车挡风玻璃清洗剂</td>
                </tr>
                <tr>
                    <td>制动液</td>
                    <td>DOT 4</td>
                </tr>
                <tr>
                    <td>冷却系统冷却液</td>
                    <td>按1:1 比例混合好的上汽通用汽车DEX-COOL长寿命发动机冷却液。</td>
                </tr>
                <tr>
                    <td>发动机舱盖及车门铰链</td>
                    <td>多用途润滑剂</td>
                </tr>
                <tr>
                    <td>钥匙锁芯</td>
                    <td>多用途润滑剂</td>
                </tr>
                <tr>
                    <td>发动机舱盖锁闩总成、辅助锁闩、枢轴、弹簧固定销和释放棘爪</td>
                    <td>满足NLGI #2 的LB 或GC-LB 类别要求的润滑剂</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
  name: 'OilAndGrease'
}
</script>

<style scoped lang="less">
    .oilAnd-grease {
        padding: 10px;
        box-sizing: border-box;
    }

    table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border-width: 0px;
    border-style: hidden;

    &,
    th,
    td {
        border: 2px solid #e3e3e3;
    }

    th,
    td {
        word-break: break-all;
    }

    th {
        font-size: 14px;
        color: #666;
        line-height: 36px;
        background-color: #eee;
    }

    td {
        box-sizing: border-box;
        padding: 10px;
        width: 50%;
        font-size: 12px;
        color: #7b7b7b;
        line-height: 1.5;
        text-align: center;
    }

    tbody tr:nth-child(even) {
        background-color: #f7f7f7;
    }
    }
</style>
